// Better Auth verifies the email server-side at /api/auth/verify-email and
// then 302-redirects to whatever callbackURL we passed at signup. This page
// is that callback — by the time the browser lands here, email_verified is
// already true in the DB. We only show a confirmation and route the user
// onward (back into checkout if that's where the flow started, otherwise
// to the sign-in page so the user can log in manually).

import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { CheckCircle } from "lucide-react";

const EmailConfirmSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("redirect_to");
  const isCheckoutFlow = redirectTo?.startsWith("/checkout/") ?? false;

  useEffect(() => {
    const target = isCheckoutFlow ? redirectTo! : "/auth";
    const id = setTimeout(() => navigate(target, { replace: true }), 1500);
    return () => clearTimeout(id);
  }, [isCheckoutFlow, redirectTo, navigate]);

  return (
    <div className="container max-w-md mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 text-center">
        <div className="flex justify-center mb-4">
          <CheckCircle className="h-16 w-16 text-green-500" />
        </div>

        <h1 className="text-2xl font-bold mb-4">
          E-posti aadress on kinnitatud!
        </h1>

        <Alert className="mb-6 bg-green-50 border-green-200">
          <AlertDescription>
            Täname, et kinnitate oma e-posti aadressi. Teie konto on nüüd aktiveeritud.
            {isCheckoutFlow
              ? " Teid suunatakse tagasi ostuprotsessi."
              : " Saate nüüd sisse logida."}
          </AlertDescription>
        </Alert>

        <p className="text-gray-600 mb-6">
          {isCheckoutFlow
            ? "Teid suunatakse automaatselt tagasi ostuprotsessi..."
            : "Teid suunatakse automaatselt sisselogimise lehele..."}
        </p>

        <Button
          onClick={() => navigate(isCheckoutFlow ? redirectTo! : "/auth", { replace: true })}
          className="w-full"
        >
          {isCheckoutFlow ? "Jätka ostuga" : "Logi sisse kohe"}
        </Button>
      </div>
    </div>
  );
};

export default EmailConfirmSuccess;
